import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestConsentGet = {
  path: "/consent",
  method: RouteHttpVerb.GET,
  obfuscatePath: "keep-last-part"
};